<template>
    <div class="mod-config">
        <div style="border-radius: 30px">
            <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-row>
                  <el-form-item label="子公司" prop="subcompanyId">
                    <el-select  v-model="subcompanyId" @change="getSupCompanyList" style="width: 100%">
                      <el-option
                          v-for="item in supCompanyList"
                          :key="item.id"
                          :label="item.orgName"
                          :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                    <el-form-item label="供应商代码" prop="venderCode">
                        <el-input size="mini" v-model="venderCode" style="width: 150px" placeholder="供应商代码" clearable @blur="getDataList"></el-input>
                    </el-form-item>
                    <el-form-item label="供应商名称" prop="venderName">
                        <el-input size="mini" v-model="venderName" style="width: 150px" placeholder="供应商名称" clearable @blur="getDataList"></el-input>
                    </el-form-item>
                    <el-form-item label="冻结状态" prop="value">
                        <el-select clearable v-model="value" placeholder="请选择" style="width: 100px" @change="getDataList">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  <el-form-item label="优先供应商" prop="isFirstlist">
                    <el-select clearable v-model="value1" placeholder="请选择" style="width: 100px" @change="getDataList">
                      <el-option
                          v-for="item in options3"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="黑名单供应商" prop="isBlacklist">
                    <el-select clearable v-model="value2" placeholder="请选择" style="width: 100px" @change="getDataList">
                      <el-option
                          v-for="item in options3"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="物料分类" prop="materialGroup">
                    <el-input size="mini" v-model="materialGroup" style="width: 150px" placeholder="物料分类" clearable @blur="getDataList"></el-input>
                  </el-form-item>
                    <el-button size="mini" @click="queryHandle()" icon="el-icon-search" style="margin-left:20px">查询</el-button>
                    <el-form-item class="fr">
                        <el-button :loading="synSAPLoading" v-if="isAuth('supplier:sipplierInfo:syncSAP')" type="success" size="mini" @click="synSAP()">同步SAP</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <div v-loading="dataListLoading">
        <el-table :data="dataList" size="mini" :row-class-name="rowClassName"
                  :height="style.gridStyle.height" @selection-change="selectionChangeHandle" border :header-cell-style="{background:'#f5f5f5'}">
            <el-table-column align="center" v-model="something" type="selection" width="55">
            </el-table-column>
            <el-table-column header-align="center" label="序号" align="center" width="55">
                <template slot-scope="scope">
                    {{ scope.row.rowid }}
                </template>
            </el-table-column>
            <el-table-column prop="freezingThaw" header-align="center" align="center" label="冻结状态" min-width="70">
                <template slot-scope="scope">
                    <span v-if="scope.row.freezingThaw === '1'" style="color:#67C23A">正常</span>
                    <span v-else-if="scope.row.freezingThaw === '0'" style="color:#909399">冻结</span>
                </template>
            </el-table-column>
          <el-table-column prop="subcompanyId" header-align="center" align="center" label="子公司" min-width="130">
            <template slot-scope="scope">
              {{ getCompanyNameById(scope.row.subcompanyId) }}
            </template>
          </el-table-column>
            <el-table-column prop="supplierLevel" header-align="center" align="center" label="状态" min-width="130">
                <template slot-scope="scope">
                    <span v-if="scope.row.supplierLevel == '1'">合格</span>
                </template>
            </el-table-column>
          <el-table-column prop="isFirstlist" header-align="center" align="center" label="优先" min-width="130">
            <template slot-scope="scope">
              <span v-if="scope.row.isFirstlist === 1">是</span>
              <span v-if="scope.row.isFirstlist !== 1">否</span>
            </template>
          </el-table-column>
          <el-table-column prop="isBlacklist" header-align="center" align="center" label="黑名单" min-width="130">
            <template slot-scope="scope">
              <span v-if="scope.row.isBlacklist=== 1">是</span>
              <span v-if="scope.row.isBlacklist!== 1">否</span>
            </template>
          </el-table-column>
            <el-table-column prop="venderLogin" header-align="center" align="left" label="供应商账号" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderLogin }}
                </template>
            </el-table-column>
            <el-table-column prop="venderCode" header-align="center" align="left" label="供应商代码" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderCode }}
                </template>
            </el-table-column>
            <el-table-column prop="venderName" header-align="center" align="left" label="供应商名称" min-width="200">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.supplierLevel !== '2'" type="text" @click="handleUpdate(scope.row)"> {{ scope.row.venderName }}</el-button>
                    <el-button v-if="scope.row.supplierLevel === '2'" type="text" @click="updateDisposableView(scope.row)"> {{ scope.row.venderName }}</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="venderAbbreviation" header-align="center" align="left" label="供应商简称" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderAbbreviation }}
                </template>
            </el-table-column>
            <el-table-column prop="venderAdd" header-align="center" align="left" label="供应商地址" width="250">
                <template slot-scope="scope">
                    {{ scope.row.venderAdd }}
                </template>
            </el-table-column>
            <el-table-column prop="venderContacts" header-align="center" align="left" label="联系人" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderContacts }}
                </template>
            </el-table-column>
            <el-table-column prop="venderMail" header-align="center" align="right" label="邮箱" width="200">
                <template slot-scope="scope">
                    {{ scope.row.venderMail }}
                </template>
            </el-table-column>
            <el-table-column prop="venderTel" header-align="center" align="right" label="联系电话" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderTel }}
                </template>
            </el-table-column>
            <el-table-column prop="sapPayCondition" header-align="center" align="center" label="付款条件" min-width="130">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.sapPayCondition === 'V000'" size="small">预付款</el-tag>
                    <el-tag v-if="scope.row.sapPayCondition === 'V001'" size="small">立即付款</el-tag>
                    <el-tag v-if="scope.row.sapPayCondition === 'V030'" size="small">30 天账期</el-tag>
                    <el-tag v-if="scope.row.sapPayCondition === 'V045'" size="small">45 天账期</el-tag>
                    <el-tag v-if="scope.row.sapPayCondition === 'V050'" size="small">50 天账期</el-tag>
                    <el-tag v-if="scope.row.sapPayCondition === 'V060'" size="small">60 天账期</el-tag>
                    <el-tag v-if="scope.row.sapPayCondition === 'V090'" size="small">90 天账期</el-tag>
                  <el-tag v-if="scope.row.sapPayCondition === 'V120'" size="small">120 天账期</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="sapZwels" header-align="center" align="center" label="付款方式" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.sapZwels }}
                </template>
            </el-table-column>
            <el-table-column prop="sapSynState" header-align="center" align="center" label="SAP同步状态" min-width="130">
                <template slot-scope="scope">
                    <span style="color:#409EFF" v-if="scope.row.sapSynState == '0'">未同步</span>
                    <span style="color:#67C23A" v-if="scope.row.sapSynState == '1'">同步成功</span>
                    <span style="color:#E6A23C" v-if="scope.row.sapSynState == '2'">同步失败</span>
                </template>
            </el-table-column>
          <el-table-column prop="materialGroup" header-align="center" align="right" label="物料分类" min-width="130">
            <template slot-scope="scope">
              {{ scope.row.materialGroup }}
            </template>
          </el-table-column>
            <!-- <el-table-column prop="sapMessage" header-align="center" align="left" label="SAP同步描述" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.sapMessage }}
                </template>
            </el-table-column> -->
            <el-table-column v-if="isAuth('supplier:sipplierInfo:freezingThaw')" fixed="right" header-align="center" align="center" label="操作" min-width="300px">
                <template slot-scope="scope">
                    <div v-if="scope.row.applyStatus === null || scope.row.applyStatus === '提交供应商解冻申请' || scope.row.applyStatus === '提交供应商冻结申请'">
                      <el-button type="text" size="small" @click="methodFrozen(scope.row)" v-if="scope.row.freezingThaw === '1'" icon="el-icon-lock">冻结</el-button>
                      <el-button type="text" size="small" @click="methodThaw(scope.row)" v-else-if="scope.row.freezingThaw === '0'" icon="el-icon-unlock">解冻</el-button>
                      <el-button type="text" size="small" @click="methodMaintain(scope.row)" icon="el-icon-edit">维护</el-button>
                      <el-button type="text" size="small" @click="methodFirst(scope.row)" icon="el-icon-location-outline">优先</el-button>
                      <el-button type="text" size="small" @click="methodBlack(scope.row)" icon="el-icon-location">黑名单</el-button>
                    </div>
                    <el-button type="text" size="small"  v-if="scope.row.applyStatus !== null && scope.row.applyStatus !== '提交供应商解冻申请' && scope.row.applyStatus !== '提交供应商冻结申请'" icon="el-icon-lock">审批中</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        </div>

        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>

        <frozenThaw v-if="frozenThawVisible" ref="frozenThaw" @refreshDataList="getDataList"></frozenThaw>
        <mainTain v-if="mainTainVisible" ref="mainTain" @refreshDataList="getDataList"></mainTain>

        <inExit v-if="inExitVisible" ref="inExit" @refreshDataList="getDataList"></inExit>
        <isBlack v-if="isBlackVisible" ref="isBlack" @refreshDataList="getDataList"></isBlack>
      
        <el-dialog class="abow_dialog " width="90%" top=0 :title="this.activeName" :visible.sync="gpsdialog"
                   style="min-height:100px" @close="closegps" :close-on-click-modal="false">
            <div style="min-hight:100px">
                <div style="margin-top:5px">
                    <div>
                        
                            <el-tabs class="supplier-info-tabs" v-model="activeName" type="card" @tab-click="handleClick">
                                <el-tab-pane label="企业概况" name="企业概况" :key="'first'">
                                    <span slot="label"><span style="color: red">*</span> 企业概况</span>
                                    <enterprise-profile ref="enterpriseProfile" :superId="this.supplierId"></enterprise-profile>
                                </el-tab-pane>
                                <el-tab-pane label="主要联系人员" name="主要联系人员" :key="'second'">
                                    <span slot="label"><span style="color: red">*</span> 主要联系人员</span>
                                    <main-contacts ref="mainContacts" :superId="this.supplierId"></main-contacts>
                                </el-tab-pane>
                                <el-tab-pane label="企业资源情况" name="企业资源情况">
                                    <span slot="label"><span style="color: red">*</span> 企业资源情况</span>
                                    <resource-info ref="resourceInfo" :superId="this.supplierId"></resource-info>
                                </el-tab-pane>
                                <el-tab-pane label="工厂及地址" name="工厂及地址">
                                    <span slot="label"><span style="color: red">*</span> 工厂及地址</span>
                                    <factory-info ref="factoryInfo" :superId="this.supplierId"></factory-info>
                                </el-tab-pane>
                                <el-tab-pane label="企业经营状况" name="企业经营状况">
                                    <span slot="label"><span style="color: red">*</span> 企业经营状况</span>
                                    <business-info ref="businessInfo" :superId="this.supplierId"></business-info>
                                </el-tab-pane>
                                <el-tab-pane label="主要产品目录" name="主要产品目录">
                                    <span slot="label"><span style="color: red">*</span> 主要产品目录</span>
                                    <product-info ref="productInfo" :superId="this.supplierId"></product-info>
                                </el-tab-pane>
                                <el-tab-pane label="附件上传" name="附件上传">
                                    <span slot="label"><span style="color: red">*</span> 附件上传</span>
                                    <attachment-upload ref="attachmentUpload" :superId="this.supplierId"></attachment-upload>
                                </el-tab-pane>
                              <el-tab-pane label="准入数据" name="准入数据">
                                <span slot="label"><span style="color: red">*</span> 准入数据</span>
                                <supplier-inquiry-view
                                    ref="supplierInquiryView"
                                    :venderinviteId="venderinviteId"
                                    :temp="temp"
                                    :showEditButton = 'false'
                                ></supplier-inquiry-view>
                              </el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
            </div>
        </el-dialog>
        
        <!-- 创建一次性 -->
        <el-dialog class="abow_dialog " width="90%" top=0 :title="this.activeName2" :visible.sync="gpsdialog2"
                   style="min-height:100px" @close="closegps" :close-on-click-modal="false">
            <div style="min-hight:100px">
                <div style="margin-top:5px">
                    <div>
            
            <el-tabs class="supplier-info-tabs" v-model="activeName2" type="card" @tab-click="handleClick2">
                <el-tab-pane name="企业概况" :key="'first'">
                    <span slot="label"><span style="color: red">*</span> 企业概况</span>
                    <enterprise-profile2 ref="enterpriseProfile2" :superId="this.supplierId"></enterprise-profile2>
                </el-tab-pane>
                <el-tab-pane label="主要联系人员" name="主要联系人员" :key="'second'">
                    <span slot="label"><span style="color: red">*</span> 主要联系人员</span>
                    <main-contacts2 ref="mainContacts2" :superId="this.supplierId"></main-contacts2>
                </el-tab-pane>
                <el-tab-pane label="企业资源情况" name="企业资源情况">
                    <span slot="label"><span style="color: red">*</span> 企业资源情况</span>
                    <resource-info2 ref="resourceInfo2" :superId="this.supplierId"></resource-info2>
                </el-tab-pane>
                <el-tab-pane label="工厂及地址" name="工厂及地址">
                    <span slot="label"><span style="color: red">*</span> 工厂及地址</span>
                    <factory-info2 ref="factoryInfo2" :superId="this.supplierId"></factory-info2>
                </el-tab-pane>
                <el-tab-pane label="企业经营状况" name="企业经营状况">
                    <span slot="label"><span style="color: red">*</span> 企业经营状况</span>
                    <business-info2 ref="businessInfo2" :superId="this.supplierId"></business-info2>
                </el-tab-pane>
                <el-tab-pane label="主要产品目录" name="主要产品目录">
                    <span slot="label"><span style="color: red">*</span> 主要产品目录</span>
                    <product-info2 ref="productInfo2" :superId="this.supplierId"></product-info2>
                </el-tab-pane>
                <el-tab-pane label="附件上传" name="附件上传">
                    <span slot="label"><span style="color: red">*</span> 附件上传</span>
                    <attachment-upload2 ref="attachmentUpload2" :superId="this.supplierId"></attachment-upload2>
                </el-tab-pane>
              <el-tab-pane label="准入数据" name="准入数据">
                <span slot="label"><span style="color: red">*</span> 准入数据</span>
                <supplier-inquiry-view
                    ref="supplierInquiryView"
                    :venderinviteId="venderinviteId"
                    :temp="temp"
                    :showEditButton = 'false'
                ></supplier-inquiry-view>
              </el-tab-pane>
            </el-tabs>
        </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="当前处理含发送邮件，请耐心等待！" :modal='true' :center='true' :visible.sync="qualifiedInviteLoading"
            :modal-append-to-body='false' :append-to-body='false' width='400px'
            :close-on-click-modal='false' :close-on-press-escape='false' :show-close='false'>
        </el-dialog>
    </div>
</template>
<script>
    import {selectSupplierPage,deleteSupplierById,qualifiedInvite,supplierDisposableCodeApply,synSAP,listSupplierInquiry} from '@/controller/supplier'
    import AddOrUpdate from './supplier-info-add-or-update'
    import FrozenThaw from './frozenThaw'
    import MainTain from './mainTain'
    import InExit from './inExit'
    import isBlack from './isBlack.vue'
    // 展示供应商基本信息
    import EnterpriseProfile from '@/views/modules/supplier/common/basicInfo/enterpriseProfile'
    import MainContacts from '@/views/modules/supplier/common/basicInfo/mainContacts'
    import ResourceInfo from '@/views/modules/supplier/common/basicInfo/resourceInfo'
    import FactoryInfo from '@/views/modules/supplier/common/basicInfo/factoryInfo'
    import BusinessInfo from '@/views/modules/supplier/common/basicInfo/businessInfo'
    import ProductInfo from '@/views/modules/supplier/common/basicInfo/productInfo'
    import AttachmentUpload from '@/views/modules/supplier/common/basicInfo/attachmentUpload'
    // 创建一次性供应商页面
    import EnterpriseProfile2 from './disposable/enterpriseProfile2'
    import MainContacts2 from './disposable/mainContacts2'
    import ResourceInfo2 from './disposable/resourceInfo2'
    import FactoryInfo2 from './disposable/factoryInfo2'
    import BusinessInfo2 from './disposable/businessInfo2'
    import ProductInfo2 from './disposable/productInfo2'
    import AttachmentUpload2 from './disposable/attachmentUpload2'
    import {supCompanyList} from "../../../../controller/sys";
    import SupplierInquiryView from "../supplierInquiry/supplier-view.vue";


    export default {
        name: 'PassSupplierInfoIndex',
        data() {
            return {
                SAPtextarea:'',
                synSAPLoading:false,
                qualifiedInviteLoading:false,
                // 一次性创建页面是否显示
                disposableLoading:false,
                dialogVisible: false,
                dataForm: {
                    key: ''
                },
                activeName:'',
                activeName2:'',
                gpsdialog: false,
                gpsdialog2: false,
                flag: '',
                gpsStatusvalflag: '',
                radio: '',
                radioSelect: '',  //选中的数据赋值给它
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                showUsers: false,
                venderId: '',
                venderinviteId: '',
                venderName: '',
                materialGroup:'',
                checkCreated: true,
                checkInvited: true,
                something: '',
                isBlacklist:'',
                isFirstlist:'',
                style: {
                    leftStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 325) + "px",
                        overflow: "auto"
                    },
                    rightStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 205) + "px"
                    },
                    gridStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 215) + "px"
                    }
                },
                
                dataRule: {
                    
                    
                },

                addOrUpdateVisible: false,
                frozenThawVisible: false,
                mainTainVisible: false,
                subcompanyId:'',
                venderCode : '',
                enterpriseName : '',

                options: [
                    {
                        value: '1',
                        label: '正常'
                    }, 
                    {
                        value: '0',
                        label: '冻结'
                    }
                ],
                options2:[
                    {
                        supplierLevel: '1',
                        label: '合格'
                    }
                ],
                options3:[
                    {
                        value: '1',
                        label: '是'
                    },
                    {
                        value: '0',
                        label: '否'
                    }
                ],
                value: '',
                value1:'',
                value2:'',
                supplierId:'',
                supplierLevel:'1',
                inExitVisible:false,
                isBlackVisible:false,
                supCompanyList:[],
                temp: {
                venderName : '',
                venderAdd : '',
                isPru:'',
                isGen:'',
                supcompanyCode:'',
                supgroupCode:'',
                venderType:'',
                venturePartner:'',
                empNum:'',
                venderEdge:'',
                venderContacts : '',
                venderTel : '',
                venderMail : '',
                productName:'',
                approveIssue:'',
                approveStore:'',
                approveClass:'',
                inviteStauts:'',
                createTime:'',
              },
            }
        },

        components: {
          SupplierInquiryView,
            isBlack,
            InExit,
            AddOrUpdate,
            FrozenThaw,
            MainTain,
            EnterpriseProfile,
            ResourceInfo,
            MainContacts,
            FactoryInfo,
            BusinessInfo,
            ProductInfo,
            AttachmentUpload,

            EnterpriseProfile2,
            ResourceInfo2,
            MainContacts2,
            FactoryInfo2,
            BusinessInfo2,
            ProductInfo2,
            AttachmentUpload2
        },

        activated() {
            this.getSupCompanyList()
            this.flag = this.$route.params.gpsStatusvalflag
            if (this.flag === "1") {
                this.checkCreated = true
                this.checkInvited = false
            }
            if (this.$route.query && this.$route.query.gpsStatusval && this.$route.query.gpsStatusval.length > 0) {
                this.gpsStatusval = encodeURI(JSON.stringify(this.$route.query.gpsStatusval))
            } else {
                this.gpsStatusval = ''
            }
            this.getDataList()
        },

        methods: {
            // 查询按钮
            queryHandle() {
                this.pageIndex = 1
                this.getDataList()
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true
                selectSupplierPage({
                    'pageNo': this.pageIndex,
                    'pageSize': this.pageSize,
                    'venderCode': this.venderCode,
                    'venderName' : this.venderName,
                    'freezingThaw' : this.value,
                    'supplierLevel' : this.supplierLevel,
                     'subcompanyId':this.subcompanyId,
                     'groupSupplierFlag':'0',
                     'isFirstlist':this.value1,
                     'isBlacklist':this.value2,
                     'materialGroup':this.materialGroup
                }).then(data => {
                    if (data && data.code === '00') {
                        console.log('获取到数据')
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                        this.starttime = data.starttime
                        this.endtime = data.endtime
                        this.interfacestarttime = data.endtime
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                }).catch((e) => {
                    console.log(e)
                }).finally(() => {
                    this.dataListLoading = false
                })
            },
            // 根据ID获取子公司名称
            getCompanyNameById(id) {
              if (!id) return '';
              const company = this.supCompanyList.find(item => item.id == id);
              return company ? company.orgName : '';
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            //多选
            selectionChangeHandle(val) {
                
                this.dataListSelections = val

                console.log(this.dataListSelections)
            },
            //单选
            radioChange(row) {
                this.dataListSelections = row;
            },
          //获取子公司列表
          getSupCompanyList(){
            supCompanyList().then(res=>{
              if(res && res.code == '00'){
                this.supCompanyList = res.body;
              }
            })
          },
            // 删除
            deleteHandle(row) {
              
                    //TODO
                    this.$message.error('开发中……')
                    
                    this.$confirm(`确定进行删除操作?`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        deleteSupplierById(
                            {id : row}
                            ).then(data => {
                            if (data && data.code === '00') {
                            this.$message({
                                message: '删除成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                                this.pageIndex = 1
                                this.getDataList()
                                }
                                
                            })
                            } else {
                            this.$message.error(data.msg)
                            }
                        })
                    })
            },

            //已完成未完成筛选
            handleCheckAllChange() {
                this.pageIndex = 1
                this.getDataList()
            },

            rowClassName({
                             row,
                             rowIndex
                         }) {
                //把每一行的索引放进row.id
                row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
            },

            //查看
            venderUserDetail(row) {
                row.isE = 0;
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(row)
                })
            },

            //关闭弹框的事件
            closeDialog() {
                this.getDataList()
            },

            filterHandler(value, row, column) {
                const property = column['property'];
                return row[property] === value;
            },
          

            // 冻结接口
            methodFrozen(row){
                row.isE = 0;
                this.frozenThawVisible = true
                this.$nextTick(() => {
                    this.$refs.frozenThaw.init(row)
                })
            },

            // 维护接口
            methodMaintain(row){
                row.isE = 0;
                this.mainTainVisible = true
                this.$nextTick(() => {
                    this.$refs.mainTain.init(row)
                })
            },

            // 解冻接口
            methodThaw(row){
                row.isE = 1;
                this.frozenThawVisible = true
                this.$nextTick(() => {
                    this.$refs.frozenThaw.init(row)
                })
            },

            handleClick: function () {
                if (this.activeName === '企业概况') {
                    this.$refs.enterpriseProfile.getDataList(this.superId)
                }
                if (this.activeName === '主要联系人员') {
                    this.$refs.mainContacts.getDataList(this.superId)
                }
                if (this.activeName === '企业资源情况') {
                    this.$refs.resourceInfo.getDataList(this.superId)
                }
                if (this.activeName === '工厂及地址') {
                    this.$refs.factoryInfo.getDataList(this.superId)
                }
                if (this.activeName === '企业经营状况') {
                    this.$refs.businessInfo.getDataList(this.superId)
                }
                if (this.activeName === '体系认证情况') {
                    this.$refs.certificationInfo.getDataList(this.superId)
                }
                if (this.activeName === '主要产品目录') {
                    this.$refs.productInfo.getDataList(this.superId)
                }
                if (this.activeName === '主要设备清单') {
                    this.$refs.equipmentList.getDataList(this.superId)
                }
                if (this.activeName === '附件上传') {
                    this.$refs.attachmentUpload.getDataList(this.superId)
                }
              if (this.activeName === '准入数据') {
                // 调用listSupplierInquiry接口获取准入数据
                this.loadSupplierInquiryData()
              }
            },
          loadSupplierInquiryData() {
            // 防止重复请求相同ID的数据
            if (!this.temp.venderName) {
              console.warn('供应商名称为空，无法获取准入数据');
              return;
            }

            console.log('开始获取准入数据，供应商名称:', this.temp.venderName);

            // 调用listSupplierInquiry接口，参数是当前供应商名称
            listSupplierInquiry({
              'pageNo': 1,
              'pageSize': 1,
              'venderName': this.temp.venderName // 使用当前供应商名称作为参数
            }).then(data => {
              console.log('获取准入数据结果:', data);
              if (data && data.code === '00') {
                if (data.body && data.body.records && data.body.records.length > 0) {
                  // 将接口返回的第一个匹配项设置为temp
                  const firstRecord = data.body.records[0];
                  console.log('找到准入数据，ID:', firstRecord.id);
                  this.temp = { ...this.temp, ...firstRecord };
                  this.venderinviteId = firstRecord.id || this.venderinviteId;

                  // 等待组件更新后再尝试获取文件列表
                  this.$nextTick(() => {
                    console.log('组件更新完成，尝试获取文件列表');
                    // 使用setTimeout确保组件完全渲染
                    setTimeout(() => {
                      if (this.$refs.supplierInquiryView && this.$refs.supplierInquiryView.$refs.FileUpDown) {
                        console.log('找到FileUpDown组件，调用init方法');
                        // 调用FileUpDown组件的init方法重新初始化，这会重新获取文件列表
                        this.$refs.supplierInquiryView.$refs.FileUpDown.init('view');
                      } else {
                        console.log('未找到FileUpDown组件或组件尚未完全加载');
                      }
                    }, 300); // 增加延时以确保组件完全加载
                  });
                } else {
                  console.log('没有找到对应的准入数据');
                  // 即使没有找到记录，也尝试刷新文件列表（可能需要根据当前供应商ID查找文件）
                  this.$nextTick(() => {
                    setTimeout(() => {
                      if (this.$refs.supplierInquiryView && this.$refs.supplierInquiryView.$refs.FileUpDown) {
                        console.log('无记录情况下尝试获取文件列表');
                        this.$refs.supplierInquiryView.$refs.FileUpDown.init('view');
                      }
                    }, 300);
                  });
                }
              } else {
                console.error('获取准入数据失败:', data.msg);
              }
            }).catch((e) => {
              console.error('获取准入数据异常:', e);
            });
          },
            handleUpdate(row) {
                this.gisIdKey = row.targetId
                this.gpsPid = row.pid
                this.activeName = '企业概况'
                this.gpsdialog = true
                this.targetId = row.targetId
                this.applyformId = row.applyformId
                this.statusbotton = row.applyStatus
                this.nextapplyformId = row.nextapplyformId
                this.approveLevel = row.approveLevel
                this.updatedBy = row.updatedBy
                this.supplierId = row.venderInviteFid
                this.temp = row
                this.venderinviteId = row.id
                this.$nextTick(() => {
                    this.$refs.enterpriseProfile.getDataList(row.venderInviteFid)
                })
            },

            closegps() {
                this.getDataList()
            },

            handleClick2: function () {
                if (this.activeName2 === '企业概况') {
                    this.$refs.enterpriseProfile2.getDataList(this.superId)
                }
                if (this.activeName2 === '主要联系人员') {
                    this.$refs.mainContacts2.getDataList(this.superId)
                }
                if (this.activeName2 === '企业资源情况') {
                    this.$refs.resourceInfo2.getDataList(this.superId)
                }
                if (this.activeName2 === '工厂及地址') {
                    this.$refs.factoryInfo2.getDataList(this.superId)
                }
                if (this.activeName2 === '企业经营状况') {
                    this.$refs.businessInfo2.getDataList(this.superId)
                }
                if (this.activeName2 === '体系认证情况') {
                    this.$refs.certificationInfo2.getDataList(this.superId)
                }
                if (this.activeName2 === '主要产品目录') {
                    this.$refs.productInfo2.getDataList(this.superId)
                }
                if (this.activeName2 === '主要设备清单') {
                    this.$refs.equipmentList2.getDataList(this.superId)
                }
                if (this.activeName2 === '附件上传') {
                    this.$refs.attachmentUpload2.getDataList(this.superId)
                }
            },

            // 显示新建一次性供应商页面
            updateDisposableView(row){
                this.gisIdKey = row.targetId
                this.gpsPid = row.pid
                this.activeName2 = '企业概况'
                this.gpsdialog2 = true
                this.targetId = row.targetId
                this.applyformId = row.applyformId
                this.statusbotton = row.applyStatus
                this.nextapplyformId = row.nextapplyformId
                this.approveLevel = row.approveLevel
                this.updatedBy = row.updatedBy
                this.supplierId = row.venderInviteFid
                this.temp = row
                this.venderinviteId = row.id
                this.$nextTick(() => {
                    this.$refs.enterpriseProfile2.getDataList(row.venderInviteFid)
                })
            },

            // 同步SAP
            synSAP(){
                debugger
                this.synSAPLoading = true
                if(this.dataListSelections.length === 1){
                    synSAP({venderInviteFid:this.dataListSelections[0].venderInviteFid,sid: this.dataListSelections[0].sid}).then(data => {
                        if(data && data.code === '00'){
                            this.synSAPLoading = false
                            this.$message({
                                message: 'SAP同步成功',
                                type: 'success',
                                duration: 3500,
                            })
                        }else{
                            this.$message.error(data.msg)
                            this.synSAPLoading = false
                        }
                    }).catch(()=>{this.synSAPLoading = false})
                }else{
                    this.synSAPLoading = false
                    this.$message({
                        message: '请选择一条记录',
                        type: 'warning',
                        duration: 3500,
                    })
                }
            },

            methodFirst(row){
              if(row.isFirstlist === 1){
                this.$confirm('是否发起供应商退出优先库申请？', '确认信息', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                }).then(() => {
                  row.isE = 1;
                  this.inExitVisible = true
                  this.$nextTick(() => {
                    this.$refs.inExit.init(row)
                  })

                }).catch(() => {
                });
              }else{
                this.$confirm('是否发起供应商进入优先库申请？', '确认信息', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                }).then(() => {
                  row.isE = 0;
                  this.inExitVisible = true
                  this.$nextTick(() => {
                    this.$refs.inExit.init(row)
                  })
                }).catch(() => {
                });
              }

            },
          methodBlack(row){
            if(row.isBlacklist === 1){
              this.$confirm('是否发起供应商退出黑名单申请？', '确认信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              }).then(() => {
                row.isE = 1;
                this.isBlackVisible = true
                this.$nextTick(() => {
                  this.$refs.isBlack.init(row)
                })

              }).catch(() => {
              });
            }else{
              this.$confirm('是否发起供应商进入黑名单申请？', '确认信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              }).then(() => {
                row.isE = 0;
                this.isBlackVisible = true
                this.$nextTick(() => {
                  this.$refs.isBlack.init(row)
                })
              }).catch(() => {
              });
            }
          }
        }
    }
</script>

<style lang="scss">
    .button-danger { color: #F56C6C; }
    .fr { float: right; }
</style>